import config from "../config";

const getCodesSummary = async () => {
  let url = `${config.backendUrl}/fule-codes/get-codes-summary`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token") || ""}`,
    },
  });
  const data = await res.json();
  return data;
};

export default getCodesSummary;
